import { render, staticRenderFns } from "./DepartmentDeleteButton.vue?vue&type=template&id=12f3bdbc&"
import script from "./DepartmentDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./DepartmentDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports